import calculateHash from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateHash';

function compileGeneralAdmissionCacheKey(generalAdmission, seed = null) {
    generalAdmission.cacheKey = calculateHash([
        generalAdmission.hash,
        generalAdmission.compiled,
        generalAdmission.label,
        generalAdmission.transformation,
        generalAdmission.seatsTotal,
        generalAdmission.seatsUsed,
        generalAdmission.forCashier,
        generalAdmission.enabled,
        generalAdmission.purchaseStatus,
        seed,
    ]);

    return generalAdmission;
}

export default compileGeneralAdmissionCacheKey;
